const MASK_OK = typeof CSS !== "undefined" && CSS.supports?.("-webkit-text-security", "disc");

// Write-only secret entry: masked TEXT field (not a password-type credential field) so password managers and
// anti-phishing credential heuristics ignore it. Browsers without text-security (e.g. Firefox) fall back to a password field.
export function SecretInput({ className = "field-input", ...props }) {
  return (
    <input {...props} type={MASK_OK ? "text" : "password"} autoComplete={MASK_OK ? "off" : "new-password"} spellCheck={false} autoCapitalize="off" autoCorrect="off"
      data-1p-ignore="true" data-lpignore="true" data-bwignore="true" data-form-type="other" className={`${className} masked-input`} />
  );
}
